import React from "react";

// =======================
// ✅ MTN Components
// =======================
const MtnRetail = React.lazy(() => import("../Pages/Services/Mtn/MtnRetail"));
const MtnBulk = React.lazy(() => import("../Pages/Services/Mtn/MtnBulk"));
const MtnCash = React.lazy(() => import("../Pages/Services/Mtn/MtnCash"));
const MtnRetailBill = React.lazy(() => import("../Pages/Services/Mtn/MtnRetailBill"));
const MtnBulkBill = React.lazy(() => import("../Pages/Services/Mtn/MtnBulkBill"));
// const MtnElectronicBalance = React.lazy(() => import("../Pages/Services/Mtn/MtnElectronicBalance"));

// =======================
// ✅ Syriatel Components
// =======================
const SyriatelRetail = React.lazy(() => import("../Pages/Services/Syriatel/SyriatelRetail"));
const SyriatelBulk = React.lazy(() => import("../Pages/Services/Syriatel/SyriatelBulk"));
const SyriatelCash = React.lazy(() => import("../Pages/Services/Syriatel/SyriatelCash"));
const SyriatelBill = React.lazy(() => import("../Pages/Services/Syriatel/SyriatelBill"));
const SyriatelElectronicBalance = React.lazy(() => import("../Pages/Services/Syriatel/SyriatelElectronicBalance.js"));

// ✅ بيانات خدمات MTN
export const mtnServices = [
  {
    title: "وحدات",
    description: "شحن وحدات MTN [مفرق]",
    buttonText: "تحويل",
    component: MtnRetail,
  },
  {
    title: " جملة وحدات",
    description: "شحن وحدات MTN [جملة]",
    buttonText: "تحويل",
    component: MtnBulk,
  },
  {
    title: "كاش",
    description: "شحن رصيد MTN كاش لحساب محدد.",
    buttonText: "تحويل",
    component: MtnCash,
  },
  {
    title: "فاتورة",
    description: "تسديد فاتورة MTN لمستخدم عبر رقم الهاتف.",
    buttonText: "ادفع فاتورة",
    component: MtnRetailBill,
  },
  {
    title: "فواتير",
    description: "تسديد عدة فواتير MTN دفعة واحدة.",
    buttonText: "ادفع فواتير",
    component: MtnBulkBill,
  },
  // {
  //   title: "رصيد إلكتروني",
  //   description: "شحن الرصيد MTN الإلكتروني.",
  //   buttonText: "تحويل",
  //   component: MtnElectronicBalance,
  // },
];

// ✅ بيانات خدمات Syriatel
export const syriatelServices = [
  {
    title: "وحدات",
    description: "شحن رصيد Syriatel [مفرق]",
    buttonText: "تحويل",
    component: SyriatelRetail,
  },
  {
    title: " جملة وحدات",
    description: "شحن رصيد Syriatel [جملة]",
    buttonText: "تحويل",
    component: SyriatelBulk,
  },
  {
    title: "كاش",
    description: "شحن رصيد Syriatel كاش لحساب محدد.",
    buttonText: "تحويل",
    component: SyriatelCash,
  },
  {
    title: "فاتورة",
    description: "تسديد فاتورة Syriatel عبر رقم الهاتف.",
    buttonText: "ادفع فاتورة",
    component: SyriatelBill,
  },
  {
    title: "رصيد إلكتروني",
    description: "شحن رصيد Syriatel الإلكتروني مع تحديد المحافظة.",
    buttonText: "تحويل",
    component: SyriatelElectronicBalance,
  },
];
